import React from 'react';
import PropTypes from 'prop-types';
import { Image, Grid, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Link from '../../../../lib/components/link';

import classes from './mobileFooter.css';
import TextBlurb from './TextBlurb';
import NewsletterSignUp from './NewsletterSignUp';
import MenuType from '../../../../lib/proptypes/menu.proptypes';
import twIcon from '../../../../assets/images/tw_orange.svg';
import fbIcon from '../../../../assets/images/fb_orange.svg';
import podIcon from '../../../../assets/images/podcast.svg';

const LinkColumn = ({ menu, index }) =>
  (<Grid.Column width={8} className={classes.footerLinksColumn}>
    {menu &&
      menu[index] &&
      menu[index].children.map(item =>
        (<div
          key={item.key}
          className={classes.footerLinkText}
        >
          <Link className={classes.footerLinkText} {...item} />
        </div>),
      )}
  </Grid.Column>);

const MobileFooter = ({ menu }) =>
  (<Segment basic className={classes.footerSegment}>
    <Grid divided="vertically">
      <Grid.Row className={classes.row}>
        <Grid.Column width={16} className={classes.column}>
          <div className={classes.footerLeftLabel}>
            <span className={classes.footerLeftLabelText}>Don’t miss a thing</span>
          </div>
          <div>
            <Image
              src={fbIcon}
              className={classes.icon}
              inline
              as="a"
              href="https://www.facebook.com/thehuddle"
              target="_blank"
            />
            <Image
              src={twIcon}
              className={classes.icon}
              inline
              as="a"
              href="https://www.twitter.com/TheHuddle"
              target="_blank"
            />
            <Image
              src={podIcon}
              className={classes.icon}
              inline
              as="a"
              href="https://thehuddle.com/category/fantasy-football-player-analysis-tips-advice-picks/fantasy-football-podcast/"
              target="_blank"
            />
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className={classes.row}>
        <NewsletterSignUp />
      </Grid.Row>
      <Grid.Row className={classes.row}>
        <LinkColumn menu={menu} index={0} />
        <LinkColumn menu={menu} index={1} />
      </Grid.Row>
      <Grid.Row>
        <LinkColumn menu={menu} index={2} />
        <LinkColumn menu={menu} index={3} />
      </Grid.Row>
      <Grid.Row>
        <TextBlurb />
      </Grid.Row>
    </Grid>
  </Segment>);

const mapStateToProps = state => ({
  menu: state.nav.footer,
});

MobileFooter.propTypes = {
  menu: MenuType.isRequired,
};

LinkColumn.propTypes = {
  menu: MenuType.isRequired,
  index: PropTypes.number.isRequired,
};

export default connect(mapStateToProps)(MobileFooter);



// WEBPACK FOOTER //
// ./src/app/components/Footer/MobileFooter/MobileFooter.js